import api from './index';
import getCookie from '../utils/getCookie';

function setParams(params, name) {
  const arrCookies = getCookie(name);

  if (arrCookies) {
    params[name] = JSON.parse(arrCookies); // eslint-disable-line no-param-reassign
  }

  return params;
}

export default {
  getCollections(exam) {
    const params = {};

    if (exam) {
      params.exam = exam;
    }

    setParams(params, 'cathid');

    return api.get('/collections', { params });
  },
  getConstructors(exam) {
    const params = {};

    if (exam) {
      params.exam = exam;
    }

    setParams(params, 'consid');

    return api.get('/constructors', { params });
  },
  getCollectionTickets(id) {
    const params = {};

    setParams(params, 'cathid');

    return api.get(`/collections/${id}/ticket-details`, { params });
  },
  getTicketQuestions(collectionId, ticketId) {
    const params = {};

    setParams(params, 'cathid');

    return api.get(`/collections/${collectionId}/tickets/${ticketId}/questions`, { params });
  },
  getExamQuestions(id, examType, isSimulator) {
    const params = {};

    if (!isSimulator && examType === 2) {
      params.forced_type = 3;
    }

    setParams(params, 'cathid');

    return api.get(`/collections/${id}/exam`, { params });
  },
  getConstructorQuestions(id) {
    const params = {};

    setParams(params, 'consid');

    return api.get(`/constructors/${id}/exam`, { params });
  },
  getExamAdditionalQuestions(data) {
    const params = {};

    if (data.examType === 2) {
      params.addition_questions_for_question_id = data.questionId;
      params.addition_questions_for_collection_id = data.collectionId;
      params.forced_type = 3;
    } else {
      params.addition_questions_for_theme_id = data.themeId;
    }

    setParams(params, 'cathid');

    return api.post(`/collections/${data.collectionId}/exam`, { exclude_questions: data.excludeQuestions }, { params });
  },
  getCollectionThemes(id) {
    const params = {
      collection_id: id,
    };

    setParams(params, 'cathid');

    return api.get('/themes', { params });
  },
  getThemeQuestions(theme) {
    return api.get(`/themes/${theme.theme_id}`, { params: { collection_id: theme.collection_id } });
  },
  getAdditionQuestionsForSimulator(examId, collectionId, questionId) {
    return api.post(`/collections/${examId}/exam`, {}, {
      params: {
        addition_questions_for_collection_id: collectionId,
        addition_questions_for_question_id: questionId,
      },
    });
  },
};
